<header class="aes-header container-fluid sts-object">
  <div class="row full-height relative">

          <div class="header-section full-height col-12 full-height">
            <div class="dtb full-height">
              <div class="dtr">
                <div class="dtd" [innerHTML]="config.logo | stsSafeHtml"></div>
              </div>
            </div>
          </div>

          <div class="header-section full-height col-12">
            <div class="pull-right right-header full-height full-width">
              <span class="inline-action language-links" *ngIf="config.languages && config.languages.length > 1">
                  <ng-container *ngFor="let language of config.languages; let i = index">
                  <a href="#"
                     class="language-toggle"
                     [ngClass]="{'active-language': language.locale.toLowerCase() == tenantInfo.currentLocale.toLocaleLowerCase()}"
                     (click)="setLocale(language.locale)">{{getLocale(language.locale)}}
                  </a>
                  </ng-container>
              </span>
            </div>
          </div>

  </div>
</header>
